export default __webpack_public_path__ + "static/media/ring_1.e7ed8fa4.webp";